import { DEFAULT_EDVERUM_CLIENT, EDVERUM_CLIENTS } from '@/constants/edverumClient.js';
import { initialState } from '@/Helpers.js';
import { buildAccessDeniedLocation } from '@/utilities/accessDeniedLocation.js';

/**
 * Create a Vue Router `beforeEnter` guard that only permits navigation when
 * the active Edverum client matches `allowedClient`. Otherwise, the user is
 * redirected to the `403` route.
 *
 * Mirrors the factory pattern used by FeatureMiddleware.js so that individual
 * routes can opt in via `beforeEnter: EdverumClientMiddleware('corporate')`
 * or via the pre-built {@link CorporateOnly} / {@link StanbridgeOnly} guards.
 *
 * @param {string} allowedClient
 * @returns {import('vue-router').NavigationGuardWithThis<undefined>}
 */
export default function EdverumClientMiddleware(allowedClient) {
    return function checkEdverumClient(to, from, next) {
        const currentClient = initialState('EnvironmentSettings.client', DEFAULT_EDVERUM_CLIENT);

        if (currentClient !== allowedClient) {
            next(buildAccessDeniedLocation(to, from));
        } else {
            next();
        }
    };
}

export const CorporateOnly = EdverumClientMiddleware(EDVERUM_CLIENTS.CORPORATE);
export const StanbridgeOnly = EdverumClientMiddleware(EDVERUM_CLIENTS.STANBRIDGE);
